import api from "./api";

class SocialMedias {
  get(){
    return api.get(`v1/api/countries/social-medias`);
  }
  getTypes() {
    return api.get(`v1/api/countries/social-medias/social-media-types`);
  }
}

export default new SocialMedias();
